import { useEffect, useRef } from 'react';

/** Run `onEscape` when Esc is pressed, while `active`. Modals, menus and sheets share it. */
export function useEscape(onEscape, active = true) {
  const latest = useRef(onEscape);
  latest.current = onEscape;
  useEffect(() => {
    if (!active) return undefined;
    const onKey = e => { if (e.key === 'Escape') latest.current(e); };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [active]);
}
